
import { useState } from 'react';

export default function useEditor() {
  const getEditor = () => {
    try{
    const editorString = localStorage.getItem('editor');
    const _editor = JSON.parse(editorString);
    global.config.Editor = _editor
    return _editor
    }catch(err){
      return {}
    }
  };

  const [editor, setEditor] = useState(getEditor());

  const saveEditor = __editor => {
    if(__editor){
    localStorage.setItem('editor', JSON.stringify(__editor));
    setEditor(__editor);
    }else{
      localStorage.removeItem('editor')
    }
  };

  return {
    setEditor: saveEditor,
    editor
  }
}